import React from 'react';
import { Route, Switch } from 'react-router-dom';
import NavigateRoute from 'app/layout/navigation/NavigateRoute';
import SignInCallbackWeb from 'identity/signin/SignInCallbackWeb';
import SignInCallbackCapacitor from 'identity/signin/SignInCallbackCapacitor';
import SignOut from 'identity/signout/SignOut';
import RedirectToExternalURL from 'identity/RedirectToExternalURL';
import SignUpContainer from 'identity/signup/SignUpContainer';
import RegistrationThankYou from 'identity/register/RegistrationThankYou';
import ResetPassword from 'identity/reset-password/ResetPassword';
import { routePaths } from 'services/routing';
import AuthWrapper from './AuthWrapper';
import RegisterContainer from 'identity/register/RegisterContainer';
import PlanDetails from 'components/PlanDetails/PlanDetails';
import SuccessPage from 'identity/SuccessPage/SuccessPage';
import AgreementSteps from 'shared/AgreementSteps/AgreementSteps';
import PdlRegister from 'identity/register/PdlRegister';

class UnauthenticatedRoutes extends React.Component {
  render() {
    return (
      <Switch>
        <Route exact path={routePaths.signout} component={SignOut} />
        <Route exact path={routePaths.redirectToExternalURL} component={RedirectToExternalURL} />
        <Route exact path={routePaths.signinCallback} component={SignInCallbackWeb} />
        <Route exact path={routePaths.signinCapacitor} component={SignInCallbackCapacitor} />
        <Route exact path={routePaths.registerThankyou} component={RegistrationThankYou} />
        <Route exact path={routePaths.register} component={RegisterContainer} />
        <Route exact path={routePaths.pdlRegister} component={PdlRegister} />
        <Route exact path={routePaths.registerOrg} component={SignUpContainer} />
        <Route exact path={routePaths.resetPassword} component={ResetPassword} />
        <Route exact path={routePaths.navigate} component={NavigateRoute} />
        <Route exact path={routePaths.planDetails} component={PlanDetails} />
        <Route exact path={routePaths.paymentSuccess} component={SuccessPage} />
        <Route exact path={routePaths.paymentAgreement} component={AgreementSteps} />

        <Route path={routePaths.root} component={AuthWrapper} />
      </Switch>
    );
  }
}

export default UnauthenticatedRoutes;
